import styled from 'styled-components';

const BurgerMenuStyle = styled.div`
	--burgerMenuButtonWidth: var(--sp18x);
	--burgerMenuOpenedWidth: var(--sp19x);
	--burgerMenuSvgBlockSize: var(--sp6x);
	--burgerMenuSvgSize: var(--sp3x);
	--burgerMenuPadding: calc((var(--burgerMenuButtonHeight) - var(--burgerMenuSvgBlockSize)) / 2);
	--burgerMenuTextBlockPadRight: var(--sp3x);
	--burgerMenuTextBlockPadLeft: var(--sp1x);

	--burgerMenuItemsPadTop: var(--sp1-5x);
	--burgerMenuItemsPadLeftRight: var(--sp2x);
	--burgerMenuItemsPadBottom: var(--sp1-5x);
	--burgerMenuItemLinkPadTopBottom: var(--sp1-5x);
	--burgerMenuItemCursorPadTB: var(--sp2x);
	--burgerMenuItemCursorPadLeftRight: var(--sp4x);
	--burgerMenuItemsBlockBorderRadius: var(--sp3x);

	--cursorMarginB: var(--sp1x);

	pointer-events: none;
	position: fixed;
	bottom: 0;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	isolation: isolate;
	padding-bottom: var(--burgerMenuPaddingBottom);
	z-index: 99999;

	transition: transform var(--trTime) ease-out;

	.burger-menu-button {
		position: relative;
		z-index: 1;
		width: var(--burgerMenuButtonWidth);
		height: var(--burgerMenuButtonHeight);
		display: flex;
		align-items: center;
		background-color: var(--pink1000);
		border-radius: 9999px;
		/* padding: var(--burgerMenuPadding); */
		padding: var(--burgerMenuPadding) calc(var(--burgerMenuPadding) + 0.5px);
		cursor: pointer;
	}

	.wrapper-button {
		position: absolute;
		width: var(--burgerMenuButtonWidth);
		height: 100%;
		left: 0;
	}

	.transition-first-load {
		scale: 0;
		overflow: hidden;
	}

	.first-load-burger-menu {
		width: calc(var(--burgerMenuSvgBlockSize) + var(--burgerMenuPadding) * 2);
		height: calc(var(--burgerMenuSvgBlockSize) + var(--burgerMenuPadding) * 2);
		padding: var(--burgerMenuPadding);
		overflow: hidden;
	}

	.burger-menu-svg-block {
		position: relative;
		width: var(--burgerMenuSvgBlockSize);
		height: var(--burgerMenuSvgBlockSize);
		display: grid;
		aspect-ratio: 1 / 1;
		flex-shrink: 0;
		grid-template-columns: auto auto auto;
		border-radius: 9999px;
		background-color: var(--mainColor);
		z-index: 1000;
	}

	.burger-menu-svg {
		position: absolute;
		width: var(--burgerMenuSvgSize);
		height: var(--burgerMenuSvgSize);
		stroke: var(--pink1000);

		place-self: center;
	}

	.burger-menu-text-block {
		width: 100%;
		font-size: var(--p3);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		color: var(--mainColor);
		line-height: 1;
		padding-right: var(--burgerMenuTextBlockPadLeft);
		/* padding-left: var(--burgerMenuTextBlockPadLeft);
		margin-right: auto; */

		transform: translateX(0);
		transition:
			opacity 0.3s ease-out,
			transform 0.2s ease-out;
	}

	.burger-menu-items {
		padding: var(--burgerMenuItemsPadTop) var(--burgerMenuItemsPadLeftRight) var(--burgerMenuItemsPadBottom);

		display: flex;
		flex-direction: column-reverse;
		align-items: center;
		text-align: center;
		font-size: var(--p3);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		color: var(--mainColor);
		line-height: 1;
		opacity: 0;

		/* //! content lr */
		position: absolute;
		bottom: 0;
		width: 100%;
	}

	.burger-menu-item-link {
		position: relative;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: var(--burgerMenuItemLinkPadTopBottom) 0;
		transition: color var(--trTime) ease-out;
		z-index: 1000;

		&.active {
			color: var(--pink1000);
		}
	}

	.burger-menu-item-cursor {
		position: absolute;
		bottom: 0;
		width: calc(100% - var(--burgerMenuItemCursorPadLeftRight));
		display: block;
		padding: var(--burgerMenuItemCursorPadTB) 0;
		border-radius: 9999px;
		background-color: var(--mainColor);
		width: calc(100% - var(--burgerMenuItemsPadLeftRight) * 2) !important;
		margin-bottom: calc(var(--cursorMarginB));
		width: var(--burgerMenuSvgBlockSize);
		height: var(--burgerMenuSvgBlockSize);
	}

	.wrapper-button-nav {
		pointer-events: all;
		position: relative;
	}

	.burger-menu-items-block {
		background-color: var(--pink1000);
		border-radius: 24px;
		z-index: 100;
		overflow: hidden;
		position: absolute;
		bottom: 0;
		height: 0;
		z-index: 0;
		width: 100%;
		pointer-events: none;
		will-change: width;
		opacity: 0;
		left: 50%;
		transform: translateX(-50%) !important;
	}

	.burger-menu-items {
		color: var(--mainColor);
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.wrapper-fake-size {
		pointer-events: all;
		position: absolute;
		width: var(--burgerMenuOpenedWidth);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--burgerMenuItemCursorPadTB: var(--sp1-5x);
		--burgerMenuItemLinkPadTopBottom: 10px;
		--burgerMenuItemsPadTop: 10px;
		--burgerMenuItemsPadBottom: 10px;
		--cursorMarginB: var(--sp1x);

		--burgerMenuButtonWidth: var(--sp15x);
		--burgerMenuOpenedWidth: var(--sp19x);
		--burgerMenuTextBlockPadRight: var(--sp2x);
		--burgerMenuSvgBlockSize: var(--sp5x);
		--burgerMenuSvgSize: var(--sp3x);
		--burgerMenuPadding: var(--sp0-5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--burgerMenuButtonWidth: var(--sp13x);
		--burgerMenuSvgBlockSize: var(--sp4x);
		--burgerMenuSvgSize: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default BurgerMenuStyle;
